import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {agent} from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// Thunk for saving forum answer
export const saveForumAnswer = createAsyncThunk(
  "answer/saveForumAnswer",
  async ({ user_id, ques_id, answer }, { rejectWithValue }) => {
    try {
      const response = await agent.post(API.SUBMIT_FORUM_ANSWER, {
        user_id,
        ques_id,
        answer,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// If you want to load answer data after saving answer
export const loadAnswerData = createAsyncThunk(
  "answer/loadAnswerData",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await agent.get(`${API.FORUM_USER_GET}/${userId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const answerSlice = createSlice({
  name: "answer",
  initialState: {
    forumData: [],
    status: "idle",
    error: null,
    saving: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Save Answer
      .addCase(saveForumAnswer.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(saveForumAnswer.fulfilled, (state, action) => {
        state.saving = false;
        // If API returns updated answer, update state
        state.forumData = state.forumData.map((item) =>
          item.ques_id === action.meta.arg.ques_id
            ? { ...item, user_ans: action.meta.arg.answer }
            : item
        );
      })
      .addCase(saveForumAnswer.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      })

      // Load answer data
      .addCase(loadAnswerData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loadAnswerData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.forumData = action.payload;
      })
      .addCase(loadAnswerData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default answerSlice.reducer;
